export default [
	    {
	        "id": "contents__content_type_id",
	        "header": "Content Type",
	        "fieldName": "content_types__class_name",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100,
	        "editField": "contents__content_type_id"
	    },
	    {
	        "id": "contents__json",
	        "header": "Json",
	        "fieldName": "contents__json",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "contents__enabled",
	        "header": "Enabled",
	        "fieldName": "contents__enabled",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "contents__path",
	        "header": "Path",
	        "fieldName": "contents__path",
	        "isSortable": false,
	        "isEditable": false,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 150
	    }
	];